import * as Sentry from '@sentry/react';
import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { RootRouteError } from './pages/RootRouteError';

const residentPath = /^\/(resident|stay|owner|access|quote|register|p|parking)(\/|$)/i;
const deskPath = /^\/desk(\/|$)/i;

type RouteTable = () => Promise<RouteObject[]>;

export const loadResidentRoutes: RouteTable = () => import('./residentRoutes').then((module) => module.residentRoutes);
export const loadAppRoutes: RouteTable = () => import('./routes').then((module) => module.appRoutes);
export const loadDeskRoutes: RouteTable = () => import('./features/front-desk/frontDeskRoutes').then(module => module.frontDeskRoutes);

/** Each path belongs to one route table; a table downloads the first time a navigation reaches one of its paths. */
export function routeTableFor(path: string): RouteTable {
  if (deskPath.test(path)) return loadDeskRoutes;
  return residentPath.test(path) ? loadResidentRoutes : loadAppRoutes;
}

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const routerOptions: Parameters<typeof createBrowserRouter>[1] = {
  // patch() skips routes it already holds, so repeat calls for a loaded table add nothing.
  patchRoutesOnNavigation: async ({ path, patch }) => patch(null, await routeTableFor(path)()),
};

export function createAppRouter(): ReturnType<typeof createBrowserRouter> {
  return sentryCreateBrowserRouter([{ path: '/', element: <LandingPage />, errorElement: <RootRouteError /> }], routerOptions);
}
